"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'CreatCoupon',
  data: function data() {
    return {
      pickerOptions0: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          var curDate = new Date().getTime();
          var three = 180 * 24 * 3600 * 1000;
          var threeMonths = curDate - three;
          return time.getTime() > Date.now() || time.getTime() < threeMonths;
        }
      },
      tableData: {
        data: [],
        total: 0
      },
      formData: {
        roomName: '',
        coverImg: '',
        startTime: '',
        endTime: '',
        anchorName: '',
        anchorWechat: '',
        subAnchorWechat: '',
        createrWechat: '',
        shareImg: '',
        feedsImg: '',
        isFeedsPublic: 1,
        type: 0,
        closeLike: 0,
        closeGoods: 0,
        closeComment: 0,
        closeReplay: 1,
        closeShare: 0,
        closeKf: 1,
        timeVal: [],
        coverImgLocal: '',
        feedsImgLocal: '',
        shareImgLocal: '',
        id: null
      },
      listLoading: false,
      rules: {
        roomName: [{
          required: true,
          message: '请输入直播间名称',
          trigger: 'blur'
        }, {
          min: 3,
          max: 17,
          message: '最短3个汉字，最长17个汉字，1个汉字相当于2个字符',
          trigger: 'blur'
        }],
        anchorName: [{
          required: true,
          message: '请输入直播间名称',
          trigger: 'blur'
        }, {
          min: 2,
          max: 15,
          message: '最短2个汉字，最长15个汉字，1个汉字相当于2个字符',
          trigger: 'blur'
        }],
        anchorWechat: [{
          required: true,
          message: '请输入主播微信号',
          trigger: 'blur'
        }],
        coverImgLocal: [{
          required: true,
          message: '请选择上传背景图',
          trigger: 'change'
        }],
        feedsImgLocal: [{
          required: true,
          message: '请上传频道封面图',
          trigger: 'change'
        }],
        shareImgLocal: [{
          required: true,
          message: '请上传分享图',
          trigger: 'change'
        }],
        timeVal: [{
          type: 'array',
          required: true,
          message: '请选择时间',
          trigger: 'change'
        }],
        tempRoute: {}
      }
    };
  },
  created: function created() {
    this.tempRoute = Object.assign({}, this.$route);
  },
  computed: {
    //判断是否是详情
    isDetail: function isDetail() {
      return this.$route.params.type ? true : false;
    }
  },
  mounted: function mounted() {
    this.setTagsViewTitle();
    if (this.$route.params.roomId) {
      this.getInfo();
    }
  },
  methods: {
    setTagsViewTitle: function setTagsViewTitle() {
      var title = this.$route.params.roomId ? this.isDetail ? '直播间详情' : '编辑直播间' : '添加直播间';
      var route = Object.assign({}, this.tempRoute, {
        title: this.$route.params.roomId ? "".concat(title, "-").concat(this.$route.params.roomId) : "".concat(title)
      });
      this.$store.dispatch('tagsView/updateVisitedView', route);
    },
    // 上下架 goodsId, roomId 取的是微信返回的id
    onchangeIsShow: function onchangeIsShow(row) {
      var _this2 = this;
      (0, _marketing.liveRoomGoodsonsaleApi)({
        goodsId: row.goodsId,
        roomId: this.formData.roomId,
        onSale: row.onSale
      }).then(function () {
        _this2.$message.success('操作成功');
        if (_this2.isDetail) _this2.getList();
      });
    },
    // 删除goodsId取的是微信返回的id
    handleDelete: function handleDelete(item, idx) {
      var _this3 = this;
      this.$modalSure('删除该直播商品吗？').then(function () {
        (0, _marketing.liveRoomDeletegoodsinroomApi)(_this3.$route.params.roomId, item.goodsId).then(function () {
          _this3.$message.success('删除成功');
          if (_this3.isDetail) _this3.getList();
        });
      });
    },
    //详情
    getInfo: function getInfo() {
      var _this4 = this;
      this.listLoading = true;
      (0, _marketing.liveRoomInfoApi)(this.$route.params.roomId).then(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(res) {
          var info;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.n) {
              case 0:
                if (res) {
                  info = JSON.parse(JSON.stringify(res));
                  _this4.formData = info;
                  _this4.formData.startTime = info.startTime;
                  _this4.formData.endTime = info.endTime;
                  _this4.formData.timeVal = [info.startTime, info.endTime];
                  if (_this4.isDetail) _this4.getList();
                }
                _this4.listLoading = false;
              case 1:
                return _context.a(2);
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }()).catch(function (res) {
        _this4.listLoading = false;
      });
    },
    // 点击商品图
    modalPicTap: function modalPicTap(num, tit) {
      var _this = this;
      if (_this.isDetail) return;
      this.$modalUpload(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(img) {
          var _t;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                if (!img) {
                  _context2.n = 7;
                  break;
                }
                _this.formData[tit] = img[0].sattDir;
                _t = tit;
                _context2.n = _t === 'coverImgLocal' ? 1 : _t === 'feedsImgLocal' ? 3 : 5;
                break;
              case 1:
                _context2.n = 2;
                return _this.getImgData(_this.formData[tit]);
              case 2:
                _this.formData.coverImg = _context2.v;
                return _context2.a(3, 7);
              case 3:
                _context2.n = 4;
                return _this.getImgData(_this.formData[tit]);
              case 4:
                _this.formData.feedsImg = _context2.v;
                return _context2.a(3, 7);
              case 5:
                _context2.n = 6;
                return _this.getImgData(_this.formData[tit]);
              case 6:
                _this.formData.shareImg = _context2.v;
              case 7:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }(), num, 'content');
    },
    // 传入图片地址调接口，获取到微信mediaId码
    getImgData: function getImgData(file) {
      return new Promise(function (resolve, reject) {
        (0, _marketing.liveMediaUploadlocalApi)({
          imagePath: file,
          type: 'image'
        }).then(function (res) {
          resolve(res.mediaId);
        });
      });
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.$set(this.formData, 'timeVal', e);
    },
    submitForm: function submitForm(formName) {
      var _this5 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this5.formData.startTime = _this5.formData.timeVal ? _this5.formData.timeVal[0] : '';
          _this5.formData.endTime = _this5.formData.timeVal ? _this5.formData.timeVal[1] : '';
          if (_this5.$route.params.roomId) _this5.formData.id = _this5.$route.params.roomId;
          _this5.$route.params.roomId ? (0, _marketing.liveRoomEditApi)(_this5.formData).then(function (res) {
            _this5.$message.success('编辑成功');
            _this5.$router.push({
              path: "/marketing/broadcast/room"
            });
          }).catch(function () {
            _this5.btnLoading = false;
          }) : (0, _marketing.liveRoomCreateApi)(_this5.formData).then(function (res) {
            _this5.$message.success('添加成功');
            _this5.$router.push({
              path: "/marketing/broadcast/room"
            });
          }).catch(function () {
            _this5.btnLoading = false;
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 直播间商品列表
    getList: function getList() {
      var _this6 = this;
      (0, _marketing.liveRoomGoodslistApi)(this.$route.params.roomId).then(function (res) {
        _this6.tableData.data = res;
      });
    }
  }
};